import { render, staticRenderFns } from "./RegistroHuevosCreate.vue?vue&type=template&id=1de837fa&scoped=true"
import script from "./RegistroHuevosCreate.vue?vue&type=script&lang=js"
export * from "./RegistroHuevosCreate.vue?vue&type=script&lang=js"
import style0 from "./RegistroHuevosCreate.vue?vue&type=style&index=0&id=1de837fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de837fa",
  null
  
)

export default component.exports